module.exports = __webpack_public_path__ + "static/img/active_default.0f5009ec.jpg";